<form (ngSubmit)="onSubmit()" [meta]="auftrag" #form="ngForm" column-classes="col-md-4,col-md-8">
  <div class="row">
    <div class="col-md-6 col-xs-12">
      <cap-form-row column-classes="col-md-4,col-md-3">
        <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="Jahr">
          <input
            (ngModelChange)="auftrag && (auftrag.auftragJahr = $event)"
            [ngModel]="auftrag && auftrag.auftragJahr"
            #auftragJahr
            autofocus
            name="auftragJahr"
            type="text" />
        </cap-form-control>
        <cap-form-control column-classes="col-md-2,col-md-3" invalidKey="EingabeMussValideNummerSein" labelKey="Nummer">
          <input
            (ngModelChange)="auftrag && (auftrag.auftragNr = $event)"
            [ngModel]="auftrag && auftrag.auftragNr"
            name="auftragNr"
            type="text" />
        </cap-form-control>
      </cap-form-row>

      <cap-form-control labelKey="AuftragsTyp">
        <select
          (ngModelChange)="auftrag && (auftrag.datenexportAuftragTyp = $event)"
          [ngModel]="auftrag && auftrag.datenexportAuftragTyp"
          id="datenexportAuftragTyp"
          name="datenexportAuftragTyp">
          @for (art of datenexportAuftragTyp; track art) {
            <option [ngValue]="art">
              {{ (art ? "datenexport." + art : null) | translate }}
            </option>
          }
        </select>
      </cap-form-control>

      <cap-form-control labelKey="Verarbeitungsstatus">
        <select
          (ngModelChange)="auftrag && (auftrag.exportResultWebTyp = $event)"
          [ngModel]="auftrag && auftrag.exportResultWebTyp"
          id="exportResultWebTyp"
          name="exportResultWebTyp">
          @for (status of exportResultWebTyp; track status) {
            <option [ngValue]="status">{{ status | translate }}</option>
          }
        </select>
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="ErstelltVon">
        <input [ngModel]="auftrag && auftrag.ersteller | kompaktBenutzer" name="ersteller" readonly type="text" />
      </cap-form-control>
    </div>

    <div class="col-md-6 col-xs-12">
      <cap-form-control column-classes="col-md-4,col-md-8" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="Erstelldatum">
        <cap-datepicker
          (ngModelChange)="auftrag && (auftrag.erstelldatum = $event)"
          [ngModel]="auftrag && auftrag.erstelldatum"
          name="erstelldatum">
        </cap-datepicker>
      </cap-form-control>
      <cap-form-control column-classes="col-md-4,col-md-8" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="Startdatum">
        <cap-datepicker
          (ngModelChange)="auftrag && (auftrag.startdatum = $event)"
          [ngModel]="auftrag && auftrag.startdatum"
          name="startdatum">
        </cap-datepicker>
      </cap-form-control>
      <cap-form-control column-classes="col-md-4,col-md-8" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="Enddatum">
        <cap-datepicker (ngModelChange)="auftrag && (auftrag.enddatum = $event)" [ngModel]="auftrag && auftrag.enddatum" name="enddatum">
        </cap-datepicker>
      </cap-form-control>
    </div>
  </div>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">
        {{ "Zurücksetzen" | translate }}
      </button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">
        {{ "Suche" | translate }}
      </button>
    </div>
  </div>
</form>
